'use strict';

var NAME           = 'social-share';
var NAMESPACE      = 'hogo.' + NAME;
var SELECTOR       = '.' + NAME;

var $body = $(document.body);


/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
const Social = function (el, options) {
	this.$element = $(el);
	this.options = $.extend({}, Social.DEFAULTS, options);
	this.updateOptions();
};

/**
 * Social version.
 */
Social.VERSION = '0.1.0';

/**
 * Social component defaults.
 */
Social.DEFAULTS = {
    facebook: {
        width: 560,
        height: 400,
        url: 'https://www.facebook.com/sharer.php?u={url}'
    },
    twitter: {
        width: 560,
        height: 300,
        url: 'https://twitter.com/intent/tweet?url={url}&text={title}'
    },
    google: {
        width: 560,
        height: 400,
        url: 'https://plus.google.com/share?url={url}'
    },
    linkedin: {
        width: 560,
        height: 400,
        url: 'https://www.linkedin.com/shareArticle?url={url}&title={title}'
    },
    weibo: {
        width: 560,
        height: 450,
        url: 'http://service.weibo.com/share/share.php?url={url}&appkey=&title={text}&pic=&ralateUid='
    },
    email: {
        width: 560,
        height: 400,
        url: 'mailto:?subject={title}&body={text} {url}'
    }
};


/**
 * Override current options with options found as data attributes.
 */
Social.prototype.updateOptions = function ()
{
	var $el = this.$element;
	if ($el.data('facebook-height') !== undefined) {
        this.options.facebook.height = $el.data('facebook-height');
    }
    if ($el.data('facebook-width') !== undefined) {
        this.options.facebook.height = $el.data('facebook-width');
    }
    if ($el.data('facebook-url') !== undefined) {
        this.options.facebook.height = $el.data('facebook-url');
    }

    if ($el.data('twitter-height') !== undefined) {
        this.options.twitter.height = $el.data('twitter-height');
    }
    if ($el.data('twitter-width') !== undefined) {
        this.options.twitter.height = $el.data('twitter-width');
    }
    if ($el.data('twitter-url') !== undefined) {
        this.options.twitter.height = $el.data('twitter-url');
    }

    if ($el.data('google-height') !== undefined) {
        this.options.google.height = $el.data('google-height');
    }
    if ($el.data('google-width') !== undefined) {
        this.options.google.height = $el.data('google-width');
    }
    if ($el.data('google-url') !== undefined) {
        this.options.google.height = $el.data('google-url');
    }

    if ($el.data('linkedin-height') !== undefined) {
        this.options.linkedin.height = $el.data('linkedin-height');
    }
    if ($el.data('linkedin-width') !== undefined) {
        this.options.linkedin.height = $el.data('linkedin-width');
    }
    if ($el.data('linkedin-url') !== undefined) {
        this.options.linkedin.height = $el.data('linkedin-url');
    }

    if ($el.data('baidu-height') !== undefined) {
        this.options.baidu.height = $el.data('baidu-height');
    }
    if ($el.data('baidu-width') !== undefined) {
        this.options.baidu.height = $el.data('baidu-width');
    }
    if ($el.data('baidu-url') !== undefined) {
        this.options.baidu.height = $el.data('baidu-url');
    }

    if ($el.data('weibo-height') !== undefined) {
        this.options.weibo.height = $el.data('weibo-height');
    }
    if ($el.data('weibo-width') !== undefined) {
        this.options.weibo.height = $el.data('weibo-width');
    }
    if ($el.data('weibo-url') !== undefined) {
        this.options.weibo.height = $el.data('weibo-url');
    }

    if ($el.data('email-height') !== undefined) {
        this.options.email.height = $el.data('email-height');
    }
    if ($el.data('email-width') !== undefined) {
        this.options.email.height = $el.data('email-width');
    }
    if ($el.data('email-url') !== undefined) {
		this.options.email.height = $el.data('email-url');
	}

	if ($el.data('url') !== undefined) {
		this.options.url = $el.data('url');
	}
	if ($el.data('title') !== undefined) {
		this.options.title = $el.data('title');
	}
    if ($el.data('text') !== undefined) {
        this.options.text = $el.data('text');
    }
    /*
    if ($el.data('via') !== undefined) {
        this.options.via = $el.data('via');
    }
	if ($el.data('hashtags') !== undefined) {
		this.options.hashtags = $el.data('hashtags');
	}*/
};

/**
 * Open the sharing window.
 */
Social.prototype.open = function (network)
{
    var opts = this.options[network];

    if ( ! opts) {
        return;
    }

    var url = opts.url.replace('{url}', encodeURIComponent(this.options.url));
    url = url.replace('{title}', encodeURIComponent(this.options.title));
    url = url.replace('{text}', encodeURIComponent(this.options.text));
    /*url = url.replace('{via}', encodeURIComponent(this.options.via));
    url = url.replace('{hashtags}', encodeURIComponent(this.options.hashtags));*/

    if (network === 'email') {
        window.location.href = url;
    } else {
        window.open(url, '_blank', 'width=' + opts.width + ',height=' + opts.height + ',toolbar=no,location=no,resizable=no,menubar=no,scrollbars=no,top=' + ((screen.height - opts.height) / 2) + ',left=' + ((screen.width - opts.width) / 2));
    }
};


// SOCIAL PLUGIN DEFINITION
// ========================

function Plugin (option)
{
    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }

    return this.each(function () {
        var $this = $(this);
        var options = $.extend({}, Social.DEFAULTS, $this.data(), typeof option == 'object' && option)

        var data  = $this.data(NAMESPACE);

        if ( ! data) $this.data(NAMESPACE, (data = new Social(this, options)));
        if (typeof option === 'string') data[option].apply(data, args);
    });
}

$.fn.social             = Plugin;
$.fn.social.Constructor = Social;


// APPLY TO STANDARD DATE SELECT ELEMENTS
// ======================================

$(SELECTOR).social();


// BIND EVENTS
// ===========

$(document).bind('click', SELECTOR + ' > li', function (e) {
    var network = $(e.target).closest('li').data('network');
    var $el = $(e.target).parents('ul');
    Plugin.call($el, 'open', network);
});



// EXPORT MODULE
// =============

export default Social;